import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { HourglassMediumIcon } from '@phosphor-icons/react';
import { formatDate } from '@/lib/format';
import { useTenant } from '@/tenant/TenantProvider';
import { Button } from '@/ui';

const DAY = 86_400_000;

/** Free trial granted from Super Admin (ADR-B11): how long it lasts, and the way to continue. */
export function TrialBanner() {
  const { t } = useTranslation('shell');
  const { current } = useTenant();
  const trial = current?.trial;
  if (!trial) return null;
  const days = Math.max(0, Math.ceil((new Date(trial.endsAt).getTime() - Date.now()) / DAY));
  const date = formatDate(trial.endsAt);
  const urgent = trial.expired || days <= 3;
  return (
    <div
      role="status"
      className={
        urgent
          ? 'mb-6 flex flex-wrap items-center justify-between gap-3 rounded-md border border-warning/30 bg-warning-soft px-4 py-3 text-sm text-warning-ink'
          : 'mb-6 flex flex-wrap items-center justify-between gap-3 rounded-md border border-info/20 bg-info-soft px-4 py-3 text-sm text-info-ink'
      }
    >
      <span className="flex items-start gap-2.5">
        <HourglassMediumIcon weight="duotone" className="mt-0.5 size-4 shrink-0" />
        <span>
          {trial.expired ? t('trial.ended', { date }) : t('trial.left', { count: days, date })}
        </span>
      </span>
      {current.role === 'owner' && (
        <Button asChild size="sm" variant="secondary">
          <Link to="/setup/plan">{t('trial.addCard')}</Link>
        </Button>
      )}
    </div>
  );
}
